module.exports = __webpack_public_path__ + "img/conclusion-select-disease.84cbbd0b.jpg";